<template>
  <div class="pane_body">
    <v-card color="rgb(255 255 245)" flat>
      <v-toolbar class="breads" dense flat>
        <v-breadcrumbs style="padding: 14px 20px">
          <v-breadcrumbs-item :to="{ name: 'umohe_admin.dash' }">
            Dashboard
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'umohe_admin.support_mails' }" class="capitalize">
            Mails
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item class="capitalize">
            {{ _decode(name) | capitalize }}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
        <v-spacer></v-spacer>


        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
                color="success"
                text
                x-small
                v-on="on"
                @click.stop="$set(editDialog, id, true)"
            >
              Reply Mail
            </v-btn>
          </template>
          <span>Reply {{ this._decode(name) }}'s mail </span>
        </v-tooltip>
        <ReplyMail
            v-if="editDialog[id]"
            :editDialog="editDialog[id]"
            :myId="id"
            @closeEdit="closeReply"
            @submitEdit="submitReply"
        />
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
                color="red"
                text
                x-small
                v-on="on"
                @click.stop="$set(closeMailDialog, id, true)"
            >
              close
            </v-btn>
          </template>
          <span>Close {{ this._decode(name) }}'s mail </span>
        </v-tooltip>
        <CloseMails
            v-if="closeMailDialog[id]"
            :closeMailDialog="closeMailDialog[id]"
            :myId="id"
            :name="name"
            @closeRemove="closingMail"
            @submitClose="submitClose"
        />


      </v-toolbar>

    </v-card>
    <v-container>
      <v-row>
        <v-col cols="12" lg="4">
          <div class="responsive-container details" style="background-color: white">
            <ul>
              <li>
                <div class="my_title">Full Name</div>
                <div class="my_caption">{{ message.full_name }}</div>
              </li>
              <li>
                <div class="my_title">subject</div>
                <div class="my_caption">{{ message.full_name }}</div>
              </li>
              <li>
                <div class="my_title">message</div>
                <div class="my_caption">{{ message.message }}</div>
              </li>
              <li>
                <div class="my_title">email</div>
                <div class="my_caption">{{ message.email }}</div>
              </li>
              <li>
                <div class="my_title">my source</div>
                <div class="my_caption">{{ message.my_source }}</div>
              </li>
              <li>
                <div class="my_title">other</div>
                <div class="my_caption">{{ message.other }}</div>
              </li>
              <li>
                <div class="my_title">active</div>
                <div class="my_caption">{{ message.active ? 'Yes' : 'No' }}</div>
              </li>
              <li>
                <div class="my_title">created</div>
                <div class="my_caption">{{ message.created | myDating }}</div>
              </li>
              <li>
                <div class="my_title">updated</div>
                <div class="my_caption">{{ message.updated | myDating }}</div>
              </li>
            </ul>
          </div>
        </v-col>
        <v-col cols="12" lg="8">
          <div style="background-color: white; height: 80dvh">

            <v-expansion-panels tile>
              <v-expansion-panel v-for="item in replies" :key="item.id">
                <v-expansion-panel-header>
                  {{ item.created | myDating }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mails">
                    {{ item.message }}
                  </div>

                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar
        v-model="snack.bar"
        :color="snack.color"
        :multi-line="snack.multiLine"
        :timeout="snack.timeout"
    >
      {{ snack.text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snack.bar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import utils from "@/mixins/utils";
import Restful from "@/services/RestFul";
import ReplyMail from "@/components/support/reply_mail.vue"
import CloseMails from "../../components/support/close_mail.vue"

export default {
  props: {
    id: {type: String, required: true},
    name: {type: String, required: true},
  },
  mixins: [utils],
  components: {CloseMails, ReplyMail},
  data() {
    return {
      loading: false,
      editDialog: {},
      closeMailDialog: {},
      headers: [
        {text: "id", value: "id"},
        {text: "replied", value: "created"},
        {text: "actions", value: "actions", align: "center"},
      ],
      snack: {
        color: "info",
        multiLine: true,
        bar: false,
        text: "Processing ... ",
        timeout: -1,
      },
      message: {},
      replies: [],
    }
  },
  created() {
    this.lists()
  },
  methods: {
    lists() {
      this.loading = true;
      let self = this;

      let myId = this._decode(this.id);
      Restful.support.replies(myId)
          .then((response) => {
            console.log(response);
            if (response.status === 200) {
              this.replies = response.data.replies;
              this.message = response.data.initial_message;
            } else if (response.status === 204) {
              this.replies = response.data;
            }
            this.loading = false;
          })
          .catch((error) => {
            console.log(error.response);
            self.loading = false;
          });
    },
    closeReply(p) {
      this.$set(this.editDialog, p.id, p.state);
    },
    submitReply(p) {
      this.loading = true;
      this.snack.bar = true;
      console.log("p:", p);
      let self = this;
      Restful.support.reply(p.data).then((response) => {
        // console.log('response', response);
        this.snack.color = "success";
        this.snack.text = response.data;
        this.lists();
        this.loading = false;
      }).catch((error) => {
        console.log(error.response);
        self.snack.color = "error";
        self.snack.text = error.response.data;
        self.loading = false;
      });
      this.$set(this.editDialog, p.id, p.state);
    },
    closingMail(p) {
      this.$set(this.closeMailDialog, p.id, p.state);
    },
    submitClose(p) {
      this.loading = true;
      this.snack.bar = true;
      console.log("p:", p.data);
      let self = this;
      Restful.support.close(p.data).then((response) => {
        // console.log('response', response);
        this.snack.color = "success";
        this.snack.text = response.data;
        this.lists();
        this.loading = false;
      }).catch((error) => {
        console.log(error.response);
        self.snack.color = "error";
        self.snack.text = error.response.data;
        self.loading = false;
      });
      this.$set(this.closeMailDialog, p.id, p.state);
    }
  }
}
</script>

<style scoped>
/* Mobile and small screens first (default fallback) */
.responsive-container {
  width: 100%;
  height: 30dvh; /* Fits strictly to content height */
  box-sizing: border-box;
  overflow-y: auto; /* Adds an inner scrollbar if content overflows the screen */
}

/* Wide screens desktop fallback (e.g., min-width: 1024px) */
@media (min-width: 1024px) {
  .responsive-container {
    /* dvh (Dynamic Viewport Height) prevents mobile browser UI layout jumps */
    height: 80dvh;
    display: flex;
    flex-direction: column; /* Organizes nested elements vertically */
    overflow-y: auto; /* Adds an inner scrollbar if content overflows the screen */
  }
}
</style>